<template>
  <div class="in container" ref="thisStep">
    <section class="formIntro">
      <div class="in container">
        <h4>Step 1 of {{ $store.getters['QuoteForm/maxSteps'] }} - Your details</h4>
        <p>Its important you answer all questions to the best of your ability, the detail entered will be used to calculate your savings, return on investment summary and provide you with a choice of suitable solutions from each manufacturer relevant to your specific business requirements.</p>

        <p><strong>Not a fan of forms? Click here to request a call back and have one of our Mailing Experts
          provide a quote for you.</strong></p>

        <p>Top tip: If you are currently in a contract, please have this handy to answer any questions our
          Expert may have.</p>

        <a href="/quotes-create?form=callback" class="btn btn-col">
          Request a call back
        </a>
        <!--<a href="#" class="btn btn&#45;&#45;base" tabindex="0" v-if="currentStep == 1">Lets Go!</a>-->
        <!--<a href="#" class="btn btn--base" tabindex="0" v-if="currentStep > 1" @click="stepBack">Go Back</a>-->
      </div>
    </section>
    <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.office_postcode || invalidFields.office_address}" v-show="postcode_search === true">
      <div class="inputPanel__col inputPanel__question">
        <label>Office location</label>
        <div class="inputPanel__col inputPanel__info">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
        <div class="inputPanel__errorMsg errorMsg" v-if="invalidFields.office_postcode || invalidFields.office_address">
          <p>Please enter a valid location</p>
          <p>Theres a problem with your location please try again</p>
        </div>
      </div>
      <div class="#inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
        <input id="postcode" type="text" class="inputLarge" placeholder="Postcode" v-model="office_postcode"/>
        <!--<input type="text" class="inputLarge" placeholder="House number" v-model="office_house_number"/>-->
        <div class="toggleBtns toggleBtns--fullWidth" style="margin-top:.9375rem;">
          <label @click.prevent="findAddress" style="width:100%;color:#0a70e3;">Find my address</label>
        </div>
        <select name="postagespendpermonth" v-model="office_address" v-if="addresses" style="margin-top:10px;">
          <option disabled value='null'>Please Select</option>
          <option v-for="address in addresses" :value="address" :key="address">{{ address }}</option>
        </select>
      </div>

      <info-modal>
        Please provide your office location, this way when you review historical quotes you can quickly and easy see what location the quote referred to.
      </info-modal>
    </div>


    <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.uses_franking_machine}">
      <div class="inputPanel__col inputPanel__question">
        <label>Do you currently use a franking machine?</label>
        <div class="inputPanel__col inputPanel__info">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
      </div>
      <div class="inputPanel__col inputPanel__input">
        <ul class="toggleBtns toggleBtns--inline">
          <li>
            <input type="radio" id="yes" name="useafrankingmachine" :value="true" v-model="uses_franking_machine"/>
            <label for="yes">yes</label>
          </li>
          <li>
            <input type="radio" id="no" name="useafrankingmachine" :value="false" v-model="uses_franking_machine"/>
            <label for="no">no</label>
          </li>
        </ul>
      </div>
      <error-modal>
        If you currently use a franking machine please select Yes, if you use stamps please select No.
      </error-modal>
      <info-modal>
        If you currently use a franking machine please select Yes, if you use stamps please select No.
      </info-modal>
    </div>

    <form-uses-franking-machine v-if="uses_franking_machine === true"></form-uses-franking-machine>

    <div class="inputPanel">
      <div class="inputPanel__col inputPanel__question">
        <label style="display:block;margin-bottom:15px">Please provide your email address</label>
        <label style="display:block;margin-bottom:15px">Why? We need this to send you your quote results. You can retrieve your quote later<br> using the details provided in the email.</label>
        <label>Themailingexpert.com takes data protection seriously as set out in our <a href="https://themailingexpert.com/legal-privacy/" target="_blank">privacy policy</a>.</label>
        <div class="inputPanel__col inputPanel__info" style="visibility: hidden">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
      </div>
      <div class="inputPanel__col inputPanel__input">
        <input id ="saveemail" type="email" placeholder="Email" name="saveemail" v-model="email" class="inputLarge"/>
        <input :disabled="button_state" type="submit" value="Continue" @click.prevent="submitQuote" id="detailsStep1Submit" class="btn btn-gradient" style="border: none; padding: 10px 20px; border-radius: 10px;display:block;margin:30px auto" />
      </div>
    </div>

    <div class="inputPanel">
      <div class="inputPanel__col inputPanel__question">
        <div class="inputPanel__col inputPanel__info" style="visibility: hidden">
          <div class="infoIcon" data-tip="Info here">
            i
          </div>
        </div>
      </div>
      <div class="inputPanel__col inputPanel__input" style="text-align: right"></div>
    </div>

  </div>

</template>
<script>
  import {mapMutations, mapState, mapActions} from 'vuex'
  import FormUsesFrankingMachine from './Form_UsesFrankingMachine.vue'
  import InfoModal from '../../InfoModal.vue'
  import ErrorModal from '../../ErrorModal.vue'

  export default {

    components: {
      'info-modal': InfoModal,
      'error-modal': ErrorModal,
      'form-uses-franking-machine': FormUsesFrankingMachine
    },

    data() {
      return {
        postcode_search: true,
        button_state :  false,
      }
    },

    computed: {
      ...mapState('QuoteForm', ['step1', 'addresses', 'invalidFields']),
      uses_franking_machine: {
        get() {
          return this.step1.uses_franking_machine
        },
        set(value) {
          this.updateStep1({
            uses_franking_machine: value,
            franking_contract: null,
            franking_indicia: null,
            franking_postage_payment: null,
            printer_model_id: null,
            franking_quadient_plan: null,
            franking_quote_type: null,
            postage_spend_per_month: null,
            postage_spend_custom: null,
          })
        }
      },
      office_address: {
        get() {
          return this.step1.office_address
        },
        set(value) {
          this.updateStep1({office_address: value})
        }
      },
      office_postcode: {
        get() {
          return this.step1.office_postcode
        },
        set(value) {
          this.updateStep1({office_postcode: value})
        }
      },
      office_house_number: {
        get() {
          return this.step1.office_house_number
        },
        set(value) {
          this.updateStep1({office_house_number: value})
        }
      },
      email: {
        get() {
          return this.step1.email
        },
        set(value) {
          this.updateStep1({email: value})
          this.updateFormData({email: value})
        }
      },
    },


    methods: {
      ...mapMutations('QuoteForm', ['updateStep1']),
      ...mapMutations('LeadForm', ['updateFormData']),
      ...mapActions('QuoteForm', ['createQuote', 'findAddress']),
      ...mapActions('QuoteForm', ['createQuote', 'updateQuote']),

      checkIfPropertiesExist(object, array) {
        let value = true
        array.forEach((item) => {

          if (object[item] === null || object[item] === '') {
            value = false
          }
        })

        return value
      },
      submitQuote() {
        this.button_state = "disabled";
        if (this.quote_id) {
          this.updateQuote(1)
        } else {
          this.createQuote()
        }
        this.$nextTick(() => {
          if (this.$store.state.QuoteForm.invalidFields) {
            let firstError = this.$refs.thisStep.querySelector('.frankinForm__stepOne .inputPanel__error')
            firstError.scrollIntoView()
            this.button_state = false;
          } else {
            this.button_state = true;
            window.scrollTo(0, 0)
          }
        })
      }
    }


  }
</script>



// WEBPACK FOOTER //
// src/views/Quotes/Form/Step-1/Conditionals/Form_MachinesAmountUnder10.vue